import { useQuery } from "react-query";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const useGetList = (
    schoolId,
    trainingId,
    accessToken,
    page = 1,
    pageSize = 30,
    filter
) => {
    return useQuery(
        ["campaigns", schoolId, trainingId, accessToken, page, pageSize, filter],
        async () => {
            try {
                const response = await fetch(
                    BACKEND_URL +
                    `/api/v1/schools/${schoolId}/trainings/${trainingId}/campaigns?page=${page}&pageSize=${pageSize}`,
                    {
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + accessToken,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch campaigns!");
                }
                if (response.status >= 299) {
                    throw new Error("Erreur de récupération de la liste des campagnes!");
                }
                const result = await response.json();
                return result;
            } catch (error) {
                // Handle the error
                console.error("Error fetching campaigns:", error);
                throw error;
            }
        }
    );
};


const GetOne = (schoolId, trainingId, accessToken, campaignId) => {
    return useQuery(
        ["campaign", schoolId, trainingId, accessToken, campaignId],
        async () => {
            try {
                const response = await fetch(
                    BACKEND_URL +
                    `/api/v1/schools/${schoolId}/trainings/${trainingId}/campaigns/${campaignId}`,
                    {
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + accessToken,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Erreur de récupération de la campagne!");
                }
                const result = await response.json();
                return result;
            } catch (error) {
                throw error;
            }
        }
    );
};

const CreateOne = async (schoolId, trainingId, accessToken, data) => {
    try {
        const response = await fetch(
            BACKEND_URL +
            "/api/v1/schools/" +
            schoolId +
            "/trainings/" +
            trainingId +
            "/campaigns",
            {
                method: "POST",
                body: JSON.stringify(data),
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + accessToken,
                },
            }
        );
        if (!response.ok) {
            throw new Error(`Erreur de création de la campagne!`);
        }
        let actualData = await response.json();
        return actualData;
    } catch (err) {
        throw err;
    }
};

const GetEmails = (
    schoolId,
    trainingId,
    accessToken,
    campaignId,
    page = 1,
    pageSize = 30,
    filter
) => {
    return useQuery(
        ["campaign-emails", schoolId, trainingId, accessToken, campaignId, page, pageSize, filter],
        async () => {
            try {
                const response = await fetch(
                    BACKEND_URL +
                    `/api/v1/schools/${schoolId}/trainings/${trainingId}/campaigns/${campaignId}/emails?page=${page}&pageSize=${pageSize}`,
                    {
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + accessToken,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch emails!");
                }
                if (response.status >= 299) {
                    throw new Error("Erreur de récupération des emails!");
                }
                const result = await response.json();
                return result;
            } catch (error) {
                // Handle the error
                console.error("Error fetching emails:", error);
                throw error;
            }
        }
    );
};

const GetCampaignDestinations = async (
    schoolId,
    trainingId,
    accessToken,
    data
) => {
    try {
        const response = await fetch(
            BACKEND_URL +
            `/api/v1/schools/${schoolId}/trainings/${trainingId}/campaign-destinations`,
            {
                method: "POST",
                body: JSON.stringify(data),
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + accessToken,
                },
            }
        );
        if (!response.ok) {
            throw new Error(`Erreur de récupération des destinataires!`);
        }
        let actualData = await response.json();
        return actualData;
    } catch (err) {
        throw err;
    }

};

const campaignsAPI = {
    useGetList,
    GetOne,
    CreateOne,
    GetEmails,
    GetCampaignDestinations,
};

export default campaignsAPI;
